import { defineMessages } from 'react-intl';

export default defineMessages({
    remove: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.Remove',
        defaultMessage: 'Remove'
    },
    relationshipToInsured: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.RelationshipToInsured',
        defaultMessage: 'Relationship to Insured'
    },
    reason: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.Reason',
        defaultMessage: 'Reason'
    },
    gpaReason: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.Reason for removing name',
        defaultMessage: 'Reason for removing {name}?'
    },
    yesRemove: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.YesRemove',
        defaultMessage: 'Yes, Remove'
    },
    dontRemove: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.DontRemove',
        defaultMessage: 'Don\'t Remove'
    },
    removeDriver: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.Remove Driver',
        defaultMessage: 'Remove Driver'
    },
    cancel: {
        id: 'ml.quoteandbind.pa.prefill.removedriver.Cancel',
        defaultMessage: 'Cancel'
    },
    DriverHasBeenRemoved: {
        id: 'quoteandbind.pa.views.ml-pa-prefill-data-driver-status.Driver has been removed.',
        defaultMessage: 'has been removed.'
    },
    DriverHasBeenAddedAsAHouseHoldMember: {
        id: 'quoteandbind.pa.views.ml-pa-prefill-data-driver-status.Driver has been added as a household member.',
        defaultMessage: 'has been added as a household member.'
    },
    DriverHasBeenAddedAsANonDriver: {
        id: 'quoteandbind.pa.views.ml-pa-prefill-data-driver-status.Driver has been added as a non driver.',
        defaultMessage: 'has been added as a non driver.'
    },
    DriverHasBeenExcluded: {
        id: 'quoteandbind.pa.views.ml-pa-prefill-data-driver-status.Driver has been excluded and will not be covered.',
        defaultMessage: 'has been excluded and will not be covered.'
    },
    RemoveDriverExclusionHelpTitle: {
        id: 'quoteandbind.pa.views.ml-pa-prefill-remove-driver-exclusion-help.Title',
        defaultMessage: 'The driver must be either rated or excluded on this policy.'
    },
    RemoveDriverExclusionHelpText: {
        id: 'quoteandbind.pa.views.ml-pa-prefill-remove-driver-exclusion-help.Text',
        defaultMessage: 'The reason selected is not a valid reason to remove a driver.  If selecting exclusion, a form will be required to be signed and there will be no coverage for that driver on this policy.'
    },
    DOBTooltipContentRemove: {
        id: 'quoteandbind.pa.views.ml-pa-prefill-remove-driver-dob-tooltip-help.Text',
        defaultMessage: 'We need this information to provide you an accurate quote.'
    },
});
